import {atomPanelColors, atomPanelElevation} from '@s-ui/react-atom-panel'
import {PanelBasic} from '@adv-mt/mt-panel-basic'

// eslint-disable-next-line react/prop-types
export const PanelOptionWrapper = ({children}) => {
  return (
    <PanelBasic elevation={atomPanelElevation.NONE} color={atomPanelColors.DEFAULT} isMarginless>
      {children}
    </PanelBasic>
  )
}
